import React from "react";
// import LinkButton from "./LinkButton";
// import { REMA_SPONSORSHIP_PAGE_URL } from "./constants";
import { partners } from "./constants/partners";
import DownloadBrochureButton from "./DownloadBrochureButton";

const ExhibitorsAndPartners = () => {
  return (
    <section className=" flex items-center ">
      <div className="container mx-auto px-4 py-16 md:px-10 lg:py-[100px] font-sora">
        <div className="flex flex-col lg:flex-row justify-between">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-8 lg:mb-14 uppercase">
            Sponsors and <br className="hidden lg:block" /> Exhibitors
          </h2>
          <div className="lg:max-w-[560px]">
            <p className="text-lg leading-loose font-inter">
              <span className="font-bold italic">
                Be part of shaping Africa’s urban future.
              </span>{" "}
              Sponsorship and exhibition at REMA 2025 give your brand powerful
              visibility with developers, policymakers, and PropTech innovators
              driving the next generation of community living.
            </p>
            <div className="flex flex-col md:flex-row gap-3 mt-8">
              {/* <LinkButton
                className=""
                href={REMA_SPONSORSHIP_PAGE_URL}
                buttonText={"Become a Sponsor/Exhibitor"}
              /> */}
              <DownloadBrochureButton />
            </div>
          </div>
        </div>

        {partners.map((categories, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center gap-6 md:gap-16 mt-14 md:mt-28">
              <p className="font-sora font-bold uppercase md:text-2xl text-[#1a1a1a]">
                {categories.category}
              </p>
              <div className="flex-1 bg-[#11302d] h-px opacity-10" />
            </div>
            <div
              className={`grid grid-cols-2 mt-8 md:mt-14 gap-2 xl:gap-6 2xl:gap-8
                ${
                  categories.companies.length <= 2
                    ? "md:grid-cols-2 lg:grid-cols-2"
                    : categories.companies.length === 4
                    ? "md:grid-cols-4 lg:grid-cols-4"
                    : "md:grid-cols-3 lg:grid-cols-3"
                } 
                `}
            >
              {categories.companies.map((partner, index) => (
                <a
                  href={partner.webUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  className="flex items-center justify-center border col-span-1 xl:h-[154px]"
                >
                  <img
                    src={partner.logo}
                    alt=""
                    className=" object-cover h-full"
                  />
                </a>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default ExhibitorsAndPartners;
